import { contestDevice, device } from '../layouts/device';
import { BDSColor } from '../tokens/color';
import { hexToRgba } from '../utils';
import { commonTheme } from './common';
import { tapTheme } from './tap';

export const chatThemeColor = {
  ...commonTheme.color,
  field: {
    background: {
      role: '최하단에 깔리는 bg 색상',
      light: BDSColor.common.white,
      dark: BDSColor.cool[75],
    },
    side: {
      role: '사이드 메뉴에 깔리는 bg 색상',
      light: BDSColor.variant[10],
      dark: BDSColor.cool[70],
    },
    rank: {
      role: 'Text',
      light: BDSColor.variant[70],
      dark: '#000', // 미정
    },
    content: {
      role: '콘텐츠 필드 색상',
      light: BDSColor.variant[10],
      dark: BDSColor.cool[70],
    },
    input: {
      role: '인풋 필드 색상',
      light: BDSColor.variant[15],
      dark: BDSColor.cool[65],
    },
    profile: {
      role: '프로필 bg 색상',
      light: BDSColor.variant[10],
      dark: '#rgba(0,0,0,0.6)', // 미정
    },
    toast: {
      role: '',
      light: BDSColor.cool[35],
      dark: BDSColor.cool[55],
    },
    scroll: {
      role: '',
      light: hexToRgba(BDSColor.common.white, 0.2),
      dark: hexToRgba(BDSColor.cool[75], 0.2),
    },
    thumbnail: {
      role: '프로필 bg 색상',
      light: BDSColor.neutral[10],
      dark: BDSColor.cool[70],
    },
  },
  buttons: {
    default: {
      role: '기본 버튼 색상',
      light: BDSColor.neutral[20],
      dark: BDSColor.cool[50],
    },
    hover: {
      role: '기본 버튼 마우스 호버 시',
      light: BDSColor.neutral[10],
      dark: BDSColor.cool[55],
    },
    press: {
      role: '기본 버튼 클릭 시',
      light: BDSColor.variant[30],
      dark: BDSColor.cool[60],
    },
    disable: {
      role: '기본 버튼 사용 불가',
      light: BDSColor.neutral[30],
      dark: BDSColor.cool[70],
    },
    sbtn_default: {
      role: '서브 버튼 기본 색상',
      light: BDSColor.variant[45],
      dark: BDSColor.cool[55],
    },
    sbtn_hover: {
      role: '서브 버튼 마우스 호버 시',
      light: BDSColor.variant[35],
      dark: BDSColor.cool[50],
    },
    sbtn_press: {
      role: '서브 버튼 클릭 시',
      light: BDSColor.variant[50],
      dark: '#000', // 미정
    },
    thbtn_default: {
      role: '3순위 버튼 색상',
      light: BDSColor.variant[55],
      dark: BDSColor.variant[70],
    },
    btn_light: {
      role: '팔로잉 버튼 색상',
      light: BDSColor.aquamarine[0],
      dark: BDSColor.aquamarine[0],
    },
    toggle: {
      role: '토글 버튼 색상',
      light: BDSColor.neutral[20],
      dark: BDSColor.cool[60],
    },
    mode_hover: {
      role: '라이트/ 다크 모드 변환 마우스 호버 시',
      light: BDSColor.neutral[10],
      dark: BDSColor.cool[70],
    },
  },
  sideMenu: {
    menu_hover: {
      role: '사이드 메뉴 호버 시',
      light: BDSColor.cool[5],
      dark: BDSColor.cool[55],
    },
    menu_active: {
      role: '사이드 메뉴 클릭 시',
      light: BDSColor.cool[10],
      dark: BDSColor.cool[60],
    },
    new: {
      role: '만들기 버튼 기본 색상',
      light: BDSColor.skyblue_default[25],
      dark: BDSColor.skyblue_dark[25],
    },
    new_hover: {
      role: '만들기 버튼 마우스 호버 시',
      light: BDSColor.skyblue_default[50],
      dark: BDSColor.skyblue_dark[50],
    },
  },
  item: {
    badge: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.variant[65],
      dark: '#000', // 미정
    },
    review: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.skyblue_default[5],
      dark: BDSColor.skyblue_dark[5],
    },
    list_hover: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.neutral[10],
      dark: BDSColor.cool[70],
    },
    tag: {
      role: '태그 bg 색상',
      sub_description: 'Text',
      light: BDSColor.variant[15],
      dark: BDSColor.cool[65],
    },
    tag_edit: {
      role: '편집 가능한 태그 bg 색상',
      sub_description: 'Text',
      light: BDSColor.variant[30],
      dark: BDSColor.cool[60],
    },
    using_tag: {
      role: '사용 중 태그 bg 색상',
      sub_description: 'Text',
      light: hexToRgba('#63C6FC', 0.2),
      dark: hexToRgba('#63C6FC', 0.2),
    },
    highlight: {
      role: '충전소 내 강조 버튼, 텍스트 색상',
      light: BDSColor.cobalt_blue[50],
      dark: BDSColor.cobalt_blue[50],
    },
  },
  message: {
    character: {
      role: '캐릭터의 말풍선 bg 색상',
      light: BDSColor.cool[10],
      dark: BDSColor.cool[55],
    },
    user: {
      role: '사용자의 말풍선 bg 색상',
      light: BDSColor.variant[15],
      dark: BDSColor.cool[60],
    },
    narrative: {
      role: '독백 대사 bg 색상',
      light: hexToRgba(BDSColor.common.white, 0.9),
      dark: hexToRgba(BDSColor.cool[75], 0.9),
      // light: 'rgba(255, 255, 255, 0.90)',
      // dark: 'rgba(17, 17, 20, 0.60)',
    },
    action: {
      role: '지문 bg 색상',
      light: BDSColor.variant[5],
      dark: BDSColor.cool[70],
    },
  },
  popup: {
    background: {
      role: '팝업 bg 색상',
      light: BDSColor.common.white,
      dark: BDSColor.cool[65],
    },
    content: {
      role: '팝업 내의 콘텐츠 필드 색상',
      light: BDSColor.variant[15],
      dark: BDSColor.cool[70],
    },
    popup: {
      role: '팝업 내의 팝업 bg 색상',
      light: BDSColor.common.white,
      dark: BDSColor.cool[60],
    },
    input: {
      role: '팝업 내의 인풋 bg 색상',
      light: BDSColor.neutral[15],
      dark: BDSColor.cool[70],
    },
    btn_hover: {
      role: '팝업 내의 버튼 마우스 호버 시',
      light: BDSColor.neutral[10],
      dark: BDSColor.cool[55],
    },
    btn_disable: {
      role: '팝업 내의 버튼 사용 불가',
      light: BDSColor.neutral[30],
      dark: BDSColor.cool[55], // 확인 필요
    },
    btn_TXT: {
      role: '팝업 내의 버튼 텍스트 색상',
      light: BDSColor.common.white,
      dark: BDSColor.variant[60],
    },
    list_hover: {
      role: '팝업 내의 리스트 아이템 마우스 호버 시',
      light: BDSColor.neutral[10],
      dark: BDSColor.cool[55],
    },
    line_1: {
      role: '팝업 내의 라인 1',
      light: BDSColor.variant[15],
      dark: BDSColor.cool[60],
    },
    line_2: {
      role: '팝업 내의 라인 2',
      light: BDSColor.variant[25],
      dark: BDSColor.cool[55],
    },
    icon_2: {
      role: '팝업 내의 아이콘 2',
      light: BDSColor.variant[40],
      dark: BDSColor.cool[45],
    },
    icon_4: {
      role: '팝업 내의 아이콘 4',
      light: BDSColor.variant[15],
      dark: BDSColor.cool[60],
    },
    icon_5: {
      role: '팝업 내의 아이콘 5',
      light: BDSColor.variant[60],
      dark: BDSColor.neutral[40],
    },
    tag_default: {
      role: '팝업 내의 태그 bg 색상',
      light: BDSColor.variant[15],
      dark: BDSColor.cool[60],
    },
    tag_edit: {
      role: '팝업 내의 태그 편집 bg 색상',
      light: BDSColor.variant[30],
      dark: BDSColor.cool[55],
    },
  },
} as const;

export const chatBaseTheme = {
  ...commonTheme,
  color: {
    ...tapTheme.color,
    ...chatThemeColor,
    rgba: {
      rgba1: 'rgba(255, 255, 255, 0)',
      rgba2: 'rgba(255, 255, 255, 0.20)',
      rgba3: 'rgba(255, 255, 255, 0.20)',
    },
  },
  device,
  contestDevice,
} as const;

// export type ChatBaseThemeType = typeof chatBaseTheme;
